export default {
  brand: 'Evoluxu',
  hero: {
    title: 'Survive. Build. Dominate.',
    subhead: 'Welcome to Evoluxu — your ultimate ARK: Survival Ascended server. Experience next-gen survival with improved graphics, enhanced mechanics, and a powerful multiplayer world.',
    visitStore: 'Visit Store',
    copyIp: 'Copy IP',
    copied: 'Copied'
  },
  about: {
    heading: 'About the Server',
    body: 'Evoluxu.com is a premium ARK: Survival Ascended server built for both new and experienced players. We focus on stability, fair gameplay, and an engaging long-term experience. With optimized settings, active administration, and regular updates, Evoluxu delivers a high-quality survival environment.'
  },
  start: {
    heading: 'How to Start Playing',
    steps: [
      { label: 'Launch ARK: Survival Ascended', link: 'https://store.steampowered.com/app/2399830/ARK_Survival_Ascended/' },
      { label: 'Search for Evoluxu in the server list' },
      { label: 'Join the server' },
      { label: 'Create your character' },
      { label: 'Start surviving' }
    ]
  },
  fairplay: {
    heading: 'Fair Play Policy',
    body: 'We maintain a fair and respectful environment. Cheating, exploiting bugs, toxic behavior, and harassment are strictly prohibited.'
  }
}
